export default __webpack_public_path__ + "static/media/List-documentation.a4de96c9.md";